<script setup>

const props = defineProps({
    location: {
        active: Object,
        required: true,
    }
})

</script>

<template>

<div>
    <div v-if="Object.keys(location).length">
        <p>{{ location.address }}</p>
        <p v-if="location.number">Appartement n°{{ location.number }}</p>
        <p v-if="location.additional">{{ location.additional }}</p>
        <p>{{ location.zip_code }} {{ location.town }}</p>
    </div>
    <div v-else>Non renseignée</div>
</div>

</template>
